/*
 * Notes
 *
 *     Accordion states:
 *     - white green no tick [to do]   (portal-checkout__accordion-item)
 *     - green no tick       [current] (portal-checkout__accordion-item open)
 *     - grey, green tick    [done]    (portal-checkout__accordion-item collapsible passed)
 *     - grey, grey tick     [re-do]   (portal-checkout__accordion-item open passed)
 *
 */
Core.PortalAccordion = {
	init: function () {
        Core.PortalAccordion.Cache = {
            $accordionHeading: $('.portal-checkout__accordion-heading')
        }

        this.toggleAccordion();
        this.handleReviewEditBtn();
    },

    getItem: function(itemId) {
        var item = Array
                    .from(Core.PortalAccordion.Cache.$accordionHeading)
                    .find(function(item) { return item.parentElement.id === itemId});

        !item
            && console.log('Accordion item not found: #' + itemId);

        return item;
    },

    setToDone: function(itemId) {
        var item = Core.PortalAccordion.getItem(itemId);

        item
            && $(item.parentElement).addClass('collapsible passed');
    },

    clickItem: function(itemId) {
        var item = Core.PortalAccordion.getItem(itemId);

        item
            && Core.PortalAccordion.disableNextAll(item);
    },

    toggleAccordion: function () {
        Core.PortalAccordion.Cache.$accordionHeading.on('click', function(e){
            e.preventDefault();

            var $heading = $(this),
                $content = $heading.siblings('.portal-checkout__accordion-content'),
                $accordion = $heading.closest('.portal-checkout__accordion-item');
            
            if($accordion.hasClass('collapsible')) {
                if(!$accordion.hasClass('in-animate')) {
                    $accordion.addClass('in-animate').toggleClass('open');

                    ($accordion.hasClass('open'))
                        ? $content.slideDown(0)
                        : $content.slideUp(0);

                    // disable current accordion before submit
                    Core.PortalAccordion.collapsePrevAll($heading);
                    Core.PortalAccordion.disableNextAll($heading);

                    setTimeout(function(){ 
                    	$accordion.removeClass('in-animate'); 
                    }, 100);

                    Core.PortalAccordion.scrollToActive();
                }
            }            
        });
    },

    collapsePrevAll: function(elem) {
        Core.PortalAccordion.collapseGenerator('prevAll')(elem);
    },
    collapseNextAll: function(elem) {
        Core.PortalAccordion.collapseGenerator('nextAll')(elem);
    },

    disableNextAll: function (elem, current) {
        var current = current || false;
    	var $el = Core.PortalAccordion.getAccordion(elem);

        $el.addClass('open').nextAll('.portal-checkout__accordion-item').removeClass("collapsible passed open");
        
        if(current)
        	$el.removeClass("collapsible passed"); 
        
    },

    getAccordion: function(elem) {
        return $(elem).hasClass('portal-checkout__accordion-item')
                        ? $(elem)
                        : $(elem).closest('.portal-checkout__accordion-item');
    },

    collapseGenerator: function(action) {
        return function(elem) {
            var $el = Core.PortalAccordion.getAccordion(elem);

            $el.addClass('open')[action]('.portal-checkout__accordion-item').removeClass("open");
        }
    },

    scrollToActive: function () {
    	$('html, body').animate({
	        scrollTop: $(".portal-checkout__accordion-item.open").offset().top
	    }, 500);
    },

    handleReviewEditBtn: function() {
        $('#checkoutPayment').on('click', '.reviewSubmit__editBtn', function(e) {
            e.preventDefault();
            var accordionId = $(this).data('accordion-id');

            if (accordionId) {
                $("#" + accordionId).find('.portal-checkout__accordion-heading').trigger('click');
            }
        });
    },
}
